/** The festival list: where an answered card, a rejected festival or one that is gone sends the curator. */
export const LIST_PATH = "/tina/festivals";

/** Where one festival is worked: its page, by record id. */
export const pagePath = (id: string): string => `${LIST_PATH}/${id}`;
